import { render, staticRenderFns } from "./ModalCollectionCreate.vue?vue&type=template&id=299bead6&"
import script from "./ModalCollectionCreate.vue?vue&type=script&lang=js&"
export * from "./ModalCollectionCreate.vue?vue&type=script&lang=js&"
import style0 from "./ModalCollectionCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports